import ReactDOM from 'react-dom';
// import './assets/styles/sass/index.scss';
// TODO: CHECK: This ^ is getting imported even if the app is defined, have to figure out a way to stop this.
import { routing } from './AppRouting';

ReactDOM.render(routing, document.getElementById('root'));
